import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var animatedImageGallery = document.getElementById('animatedImageGallery');

var screenWidth = window.innerWidth;

window.addEventListener(
  'resize',
  function () {
    screenWidth = window.innerWidth;
    ScrollTrigger.refresh();
  },
  true
);

//observe height change of page and refresh scrll triggger when needed
const resize_ob = new ResizeObserver(function () {
  ScrollTrigger.refresh();
});
// start observing for resize
resize_ob.observe(document.body);

//if an animated hero is detected
if (animatedImageGallery) {
  let tl = gsap.timeline({
    scrollTrigger: {
      markers: false,
      trigger: '#animatedImageGalleryContainer',
      pin: false,
      start: 'center center',
      end: 'bottom bottom',
    },
    onComplete: function () {
      document
        .getElementById('animatedImageGallery')
        .classList.add('postAnimation');
    },
  });

  //if desktop
  if (screenWidth >= 1024) {
    tl.addLabel('start')
      .set(
        '#aigDescription',
        {
          top: 404,
          right: '8%',
        },
        0
      )
      .to(
        '#coloredBackground',
        {
          height: 3105,
          duration: 2,
          marginTop: 0,
          ease: 'power1',
        },
        0
      )
      .to(
        '#contentContainer',
        {
          duration: 2,
          marginTop: 0,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigHeader',
        {
          top: 180,
          duration: 1.5,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigDescription',
        {
          duration: 2,
          opacity: 1.0,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigOne',
        {
          width: 710,
          height: 544,
          top: 404,
          left: -98,
          rotation: 0,
          transform: 'translateX(0%)',
          duration: 2,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigTwo',
        {
          width: 414,
          height: 558,
          top: 948,
          right: 0,
          rotation: 0,
          transform: 'translateX(0%)',
          duration: 2,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigThree',
        {
          width: 521,
          height: 778,
          top: 1066,
          left: 0,
          rotation: 0,
          transform: 'translateX(0%)',
          duration: 2,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigFour',
        {
          width: 692,
          height: 583,
          top: 1687,
          right: -95,
          rotation: 0,
          transform: 'translateX(0%)',
          duration: 2,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigFive',
        {
          width: 437,
          height: 654,
          top: 2060,
          left: 84,
          transform: 'translateX(0%)',
          rotation: 0,
          duration: 2,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigSix',
        {
          width: 414,
          height: 558,
          top: 2451,
          right: 96,
          rotation: 0,
          transform: 'translateX(0%)',
          duration: 2,
          ease: 'power1',
        },
        0
      );
  } else {
    var headerTop, descriptionPT, backgroundHeight;
    if (screenWidth >= 768) {
      headerTop = 78;
      descriptionPT = 120;
      backgroundHeight = 1750;
    } else {
      headerTop = 40;
      descriptionPT = 100;
      backgroundHeight = 1500;
    }

    tl.addLabel('start')
      .to(
        '.aigElement',
        {
          opacity: 0,
          rotation: 0,
          duration: 1.5,
          ease: 'power1',
        },
        0
      )
      .to(
        '#coloredBackground',
        {
          height: backgroundHeight,
          duration: 4,
          marginTop: 0,
          ease: 'power1',
        },
        0
      )
      .to(
        '#contentContainer',
        {
          marginTop: 0,
          duration: 1.5,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigHeader',
        {
          top: headerTop,
          duration: 1.5,
          ease: 'power1',
        },
        0
      )
      .to(
        '#aigDescription',
        {
          paddingTop: descriptionPT,
          duration: 1.5,
          ease: 'power1',
        },
        0
      )
      .addLabel('opacityFaded', '>')
      .call(
        function () {
          document
            .getElementById('animatedImageGallery')
            .classList.add('postFade');
        },
        null,
        null,
        'opacityFaded'
      )
      .set(
        '#aigDescription',
        {
          position: 'relative',
        },
        'opacityFaded'
      )
      .set(
        '#aigHeader',
        {
          position: 'relative',
        },
        'opacityFaded'
      )
      .set(
        '#aigDescription',
        {
          position: 'relative',
        },
        'opacityFaded'
      )
      .set(
        '.aigElement',
        {
          transform: 'translateX(0%)',
          position: 'relative',
          left: 'auto',
          right: 'auto',
        },
        'opacityFaded'
      )
      .to(
        '.aigElement',
        {
          opacity: 1,
          rotation: 0,
          duration: 2,
          ease: 'power1',
        },
        'opacityFaded'
      )
      .to(
        '#aigDescription',
        {
          duration: 2,
          opacity: 1,
          ease: 'power1',
        },
        'opacityFaded'
      );
  }
}
